import {
  SidebarMenu,
  SidebarMenuItem,
} from "~/components/ui/sidebar"

export function TeamSwitcher() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "8px 0" }}>
          <img src="/logo.svg" width={48} height={48} alt="7Qz logo" />
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
